/**
 * @desc 校验SupplierCode供应商编号是否存在
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.CheckSupplierCodeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/checkSupplierCode`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
